import { render, staticRenderFns } from "./EmpresaDataV.vue?vue&type=template&id=29a0f13c"
import script from "./EmpresaDataV.vue?vue&type=script&lang=js"
export * from "./EmpresaDataV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports